import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function Cloud() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/cloud.png"
      eyebrow="Products / Cloud"
      title="Cloud"
      accent="#1378ff"
      description="Host, secure and scale digital operations."
      bullets={[
        "Infrastructure, security, and compliance in one place.",
        "Support for reliable hosting and cloud modernization.",
        "Built to keep digital systems fast and resilient.",
      ]}
      features={[
        { title: "Infrastructure", text: "Provision and manage the foundations your teams depend on." },
        { title: "Security", text: "Keep platforms secure with layered controls and visibility." },
        { title: "Compliance", text: "Support governance and operational readiness." },
      ]}
      ctaLabel="Explore Cloud"
      summaryKicker="Cloud Layer"
      summaryTitle="Build a resilient digital foundation with security and governance in view."
      summaryText="Cloud gives teams the performance and control they need to host, secure, and scale core digital operations."
    />
  );
}
